<template>
  <section class="logo-slider">
    <div class="logo-slider__navigation">
      <img
        v-if="$isMobile()"
        src="../assets/images/left-white.svg"
        @click="navSelection !== 0 ? (navSelection -= 1) : (navSelection = 4)"
      />
      <div
        class="logo-slider__navigation--item"
        v-for="(item, i) in data"
        :key="`item_${i}`"
        @click="updateSelection(i)"
        :style="navSelection === i && 'margin-top: -10px;'"
      >
        <h5
          v-if="$isMobile() && i === navSelection"
          :style="
            navSelection === i &&
            'background-color: #fff; color: var(--color-charcoal-1);'
          "
        >
          {{ item.title }}
        </h5>
        <h5
          v-if="!$isMobile()"
          :style="
            navSelection === i &&
            'background-color: #fff; color: var(--color-charcoal-1);'
          "
        >
          {{ item.title }}
        </h5>
      </div>
      <img
        v-if="$isMobile()"
        src="../assets/images/right-white.svg"
        @click="navSelection !== 4 ? (navSelection += 1) : (navSelection = 0)"
      />
    </div>
    <div class="logo-slider__information">
      <div class="logo-slider__information--left">
        <p>{{ data[navSelection].info.body }}</p>
        <a
          v-if="navSelection === 0 || navSelection === 1"
          class="button"
          target="_blank"
          href="https://s3.eu-west-1.amazonaws.com/brand-box.marketing.just-eat.com/downloads/jet-market-logos.zip"
          download
          >Download logos</a
        >
      </div>
      <div class="logo-slider__information--right">
        <img
          :src="require(`../assets/images/${data[navSelection].info.demo}`)"
        />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'LogoSlider',
  data() {
    return {
      navSelection: 0,
    }
  },
  props: {
    data: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  methods: {
    updateSelection(index) {
      this.navSelection = index
    },
  },
}
</script>

<style lang="scss">
$desktop: 1024px;
$tablet: 768px;
$mobile: 600px;

.logo-slider {
  width: 100%;
  &__navigation {
    display: flex;
    justify-content: space-around;
    border-bottom: 3px solid var(--color-white-1);
    color: var(--color-white-1);
    cursor: pointer;
    @media (max-width: $tablet) {
      justify-content: center;
      align-items: stretch;
    }
    &--item {
      text-align: center;
      h5 {
        padding: 20px;
        border-radius: 30px;
        color: var(--color-white-1);
      }
      @media (max-width: $tablet) {
        text-align: center;
      }
    }
    img {
      width: 40px;
    }
  }
  &__information {
    display: flex;
    align-items: center;
    padding: 50px;
    @media (max-width: $tablet) {
      flex-direction: column;
      padding: 20px;
      margin-bottom: 20px;
    }
    &--left {
      width: 30%;
      padding: 0 50px 0 0;
      @media (max-width: $tablet) {
        width: 100%;
        padding: 0;
      }
      p {
        margin: 50px 0;
        color: var(--color-white-1);
      }
      a {
        color: var(--color-white-1);
        border: 2px solid var(--color-white-1);
        @media (max-width: $tablet) {
          width: 90%;
          margin-bottom: 50px;
        }
      }
    }
    &--right {
      width: 70%;
      text-align: center;
      background-color: var(--color-white-1);
      border-radius: 30px;
      min-height: 400px;
      display: flex;
      align-items: center;
      justify-content: center;
      @media (max-width: $tablet) {
        width: 100%;
        min-height: 200px;
      }
      img {
        width: 80%;
        @media (max-width: $tablet) {
          width: 100%;
        }
      }
    }
  }
}
</style>